import React, {useEffect, useState} from "react";
import EAFieldset from "../EAFieldset";
import EACombobox from "../EACombobox";
import {useHttp} from "../../services/HttpService";
import {
    getAbfrageExportEndpointConfiguration,
    getAbfragenEndpoint,
} from "../../services/AnlagenService";
import EADownloadButton from "../EADownloadButton";

/**
 * Komponente zur Filterung einer Anwenderliste
 * @returns {JSX.Element}
 * @constructor
 */
function AnwenderListFilter() {

    const [currentAbfrage, setCurrentAbfrage] = useState(null);

    const [{ data: abfragen }] = useHttp(getAbfragenEndpoint());

    const [uniqueKategorien, setUniqueKategorien] = useState([]);
    const [uniqueFilter, setUniqueFilter] = useState([]);
    const [filteredAbfragen, setFilteredAbfragen] = useState([]);
    const [filtered, setFiltered] = useState(false);

    useEffect(() => {
        if (abfragen) {
            setUniqueKategorien([...new Set(abfragen.map(item => item.kategorie))]);
            setUniqueFilter([...new Set(abfragen.map(item => item.filter))]);
        }
    }, [abfragen, setUniqueFilter, setUniqueKategorien]);

    const [selectedKategorie, setSelectedKategorie] = useState('');
    const [selectedFilter, setSelectedFilter] = useState('');

    useEffect(() => {
        if (!filtered && abfragen) {
            const filteredAbfragen = abfragen.filter(abfrage => {
                if (!selectedKategorie || abfrage.kategorie === selectedKategorie) {
                    if (!selectedFilter || abfrage.filter === selectedFilter) {
                        return true;
                    }
                }
                return false;
            });

            setFilteredAbfragen(filteredAbfragen);
            setFiltered(true);
        }
    }, [abfragen, filtered, selectedFilter, selectedKategorie]);

    return (
        <EAFieldset caption="Export">
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <EACombobox
                    options={uniqueKategorien}
                    label={"Kategorie"}
                    style={{flex: 1, marginRight: "10px"}}
                    onChange={(event, newValue) => {
                        setSelectedKategorie(newValue);
                        setFiltered(false);
                    }}
                />
                <EACombobox
                    options={uniqueFilter}
                    label={"Filter"}
                    style={{flex: 1, marginRight: "10px"}}
                    onChange={(event, newValue) => {
                        setSelectedFilter(newValue);
                        setFiltered(false);
                    }}
                />
                <EACombobox
                    options={filteredAbfragen}
                    optionTitle={"abfrageBez"}
                    label={"Abfrage"}
                    style={{flex: 1, marginRight: "10px"}}
                    onChange={(event, newValue) => {
                        setCurrentAbfrage(newValue);
                    }}
                />
                <EADownloadButton
                    id={"exportAbfrage"}
                    label={"Excel-Export"}
                    disabled={!currentAbfrage}
                    config={getAbfrageExportEndpointConfiguration(currentAbfrage ? currentAbfrage.id : null)}
                    style={{marginRight: "auto"}}
                    color="primary"
                />
            </div>
        </EAFieldset>
    );
}

export default AnwenderListFilter;
